import React from 'react';

function SubscribeRadioBottom({ size, type, onClickRadio }) {
  return (
    <div className={`subscribe-${size}-radio-bottom`}>
      <hr className={`subscribe-${size}-border`} />
      <p className={`subscribe-${size}-trail`}>Unsubscribe:</p>
      <hr className={`subscribe-${size}-radio-border`} />
      <label className={`subscribe-${size}-radio-container`} onClick={onClickRadio}>
        Printed Fearless Flyer
        <input type="radio" name="type" value="mail_unsubscribe" checked={type === 'mail_unsubscribe'} readOnly />
        <span className={`subscribe-${size}-radio-check`}></span>
      </label>
      <label className={`subscribe-${size}-radio-container`} onClick={onClickRadio}>
        e-Newsletter
        <input type="radio" name="type" value="email_unsubscribe" checked={type === 'email_unsubscribe'} readOnly />
        <span className={`subscribe-${size}-radio-check`}></span>
      </label>
      <hr className={`subscribe-${size}-radio-border`} />
    </div>
  );
}

export default SubscribeRadioBottom;
